import { useCallback, useMemo } from 'react';

import { isNil } from 'ramda';

const calcWidth = (column, baseSize) => {
  if (column.fixedSize) {
    return column.fixedSize;
  }
  if (column.fitContent) {
    return '1px';
  }
  if (column.growFactor) {
    return `${column.growFactor * baseSize}%`;
  }

  return `${baseSize}%`;
};

const calcColumnBaseSize = (columns) => {
  const { totalColumnCount, totalGrowFactor } = columns.reduce(
    (acc, column) => {
      if (column.fitContent === true || column.fixedSize) {
        return { ...acc, totalColumnCount: acc.totalColumnCount - 1 };
      }

      if (!isNil(column.growFactor)) {
        return {
          ...acc,
          totalColumnCount: acc.totalColumnCount - 1,
          totalGrowFactor: acc.totalGrowFactor + column.growFactor,
        };
      }

      return acc;
    },
    { totalColumnCount: columns.length, totalGrowFactor: 0 },
  );

  const baseSize = 100 / (totalGrowFactor + totalColumnCount);

  return baseSize;
};

const useFixSizedColums = ({ columns, enabled }) => {
  const baseSize = useMemo(() => (enabled ? calcColumnBaseSize(columns) : undefined), [columns, enabled]);
  const getFixSizedColumnStyles = useCallback(
    (column) => {
      return enabled
        ? {
            width: calcWidth(column, baseSize),
            wordBreak: column.fitContent ? 'normal' : undefined,
          }
        : undefined;
    },
    [columns, enabled],
  );

  return {
    getFixSizedColumnStyles,
  };
};

export default useFixSizedColums;
